import { isFxLite } from '@utils/fxLite';

const docHidden = () => document.hidden;

/** Login/register background network — matches auth HTML template. */
export function initAuthBgFX(canvas: HTMLCanvasElement): () => void {
  // Phones render a static gradient instead (see AuthPageShell) — no loop at all.
  if (isFxLite()) return () => {};
  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  let w = 0;
  let h = 0;
  let dpr = 1;
  let raf = 0;

  type Node = { x: number; y: number; vx: number; vy: number; r: number; c: string; tw: number; ts: number };
  let nodes: Node[] = [];
  const C = ['#2f6bff', '#6d8cff', '#5b8cff', '#22d3ee'];

  const resize = () => {
    dpr = Math.min(devicePixelRatio || 1, 2);
    w = canvas.clientWidth;
    h = canvas.clientHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const n = Math.max(28, Math.min(80, Math.floor((w * h) / 12000)));
    nodes = Array.from({ length: n }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      vx: (Math.random() - 0.5) * 0.26,
      vy: (Math.random() - 0.5) * 0.26,
      r: Math.random() * 1.7 + 0.8,
      c: C[Math.floor(Math.random() * C.length)],
      tw: Math.random() * 6.28,
      ts: 0.5 + Math.random(),
    }));
  };

  const frame = () => {
    raf = requestAnimationFrame(frame);
    if (docHidden()) return;
    const t = performance.now() * 0.001;
    ctx.clearRect(0, 0, w, h);
    for (const p of nodes) {
      p.x += p.vx;
      p.y += p.vy;
      if (p.x < 0 || p.x > w) p.vx *= -1;
      if (p.y < 0 || p.y > h) p.vy *= -1;
      const a = 0.5 + 0.5 * Math.sin(t * p.ts + p.tw);
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, 6.28);
      ctx.fillStyle = p.c;
      ctx.globalAlpha = 0.55 * a;
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    for (let i = 0; i < nodes.length; i++) {
      for (let j = i + 1; j < nodes.length; j++) {
        const a = nodes[i];
        const b = nodes[j];
        const dx = a.x - b.x;
        const dy = a.y - b.y;
        const d = Math.hypot(dx, dy);
        if (d < 130) {
          ctx.globalAlpha = (1 - d / 130) * 0.26;
          ctx.strokeStyle = '#5b8cff';
          ctx.lineWidth = 0.7;
          ctx.beginPath();
          ctx.moveTo(a.x, a.y);
          ctx.lineTo(b.x, b.y);
          ctx.stroke();
        }
      }
    }
    ctx.globalAlpha = 1;
  };

  window.addEventListener('resize', resize);
  resize();
  frame();

  return () => {
    cancelAnimationFrame(raf);
    window.removeEventListener('resize', resize);
  };
}
